import {
  CREATE_CONTROL_REQUEST,
  CREATE_CONTROL_SUCCESS,
  CREATE_CONTROL_FAILURE,
  UPDATE_CONTROL_REQUEST,
  UPDATE_CONTROL_SUCCESS,
  UPDATE_CONTROL_FAILURE,
  DELETE_CONTROL_REQUEST,
  DELETE_CONTROL_SUCCESS,
  DELETE_CONTROL_FAILURE,
  GET_UNIQUE_CONTROL_REQUEST,
  GET_UNIQUE_CONTROL_SUCCESS,
  GET_UNIQUE_CONTROL_FAILURE,
  LOAD_PLAN_PATH,
  CLEAR_CONTROL } from '../constants'

import Api from '../services/api.js'
import history from '../history'
import control from '../reducers/control'

export function createControlRequest(){
  return {
    type: CREATE_CONTROL_REQUEST,
  }
}

export function createControlSuccess(body, risk_id){
  return {
    type: CREATE_CONTROL_SUCCESS,
    body: body,
    riskId: risk_id
  }
}

export function createControlFailure(exception){
  return {
    type: CREATE_CONTROL_FAILURE,
    exception: exception
  }
}

export function updateControlRequest(){
  return {
    type: UPDATE_CONTROL_REQUEST,
  }
}

export function updateControlSuccess(body, risk_id){
  return {
    type: UPDATE_CONTROL_SUCCESS,
    body: body,
    riskId: risk_id
  }
}

export function updateControlFailure(exception){
  return {
    type: UPDATE_CONTROL_FAILURE,
    exception: exception
  }
}

export function deleteControlRequest(){
  return {
    type: DELETE_CONTROL_REQUEST,
  }
}

export function deleteControlSuccess(body, risk_id){
  return {
    type: DELETE_CONTROL_SUCCESS,
    body: body,
    riskId: risk_id
  }
}

export function deleteControlFailure(exception){
  return {
    type: DELETE_CONTROL_FAILURE,
    exception: exception
  }
}

export function getUniqueControlsRequest(){
  return {
    type: GET_UNIQUE_CONTROL_REQUEST,
  }
}

export function getUniqueControlsSuccess(body){
  return {
    type: GET_UNIQUE_CONTROL_SUCCESS,
    body: body
  }
}

export function getUniqueControlsFailure(exception){
  return {
    type: GET_UNIQUE_CONTROL_FAILURE,
    exception: exception
  }
}

export function clearControl(){
  return {
    type: CLEAR_CONTROL
  }
}

export function createControl(control_details) {
  return dispatch => {
    dispatch(createControlRequest())
    const api = new Api();
    return api.post("/__api/v1/risk/"+ control_details.risk_id + "/create_control", control_details)
    .then(response => {
      dispatch(createControlSuccess(response.data, control_details.risk_id))
    })
    .catch(err => dispatch(createControlFailure(err)));
  }
}

export function updateControl(plan_id, risk_id, control) {
  let params = {
    name: control.name,
    plan_id: plan_id
  }
  return dispatch => {
    dispatch(updateControlRequest())
    const api = new Api();
    return api.put("/__api/v1/control/"+ control.id, params)
    .then(response => {
      dispatch(updateControlSuccess(response.data, risk_id))
    })
    .catch(err => dispatch(updateControlFailure(err)));
  }
}

export function deleteControl(plan_id, risk_id, control) {
  var params = {
    data: {
      plan_id: plan_id
    }
  }
  return dispatch => {
    dispatch(deleteControlRequest())
    const api = new Api();
    return api.delete("/__api/v1/control/"+ control.id, params)
    .then(response => {
      dispatch(deleteControlSuccess(response.data, risk_id))
    })
    .catch(err => dispatch(deleteControlFailure(err)));
  }
}

export function getUniqueControls(options) {
  var params = {
    include_hidden_risks: options.include_hidden_risks,
    search_term: options.search_term,
    sort_by: options.sort_by,
    column_name: options.column_name,
    filter_by_tags: options.filter_by_tags
  }
  return dispatch => {
    dispatch(getUniqueControlsRequest())
    const api = new Api();
    return api.get("/__api/v1/plan/"+ options.plan_id + "/unique_controls", {params: params})
    .then(response => {
      dispatch(getUniqueControlsSuccess(response.data))
    })
    .catch(err => dispatch(getUniqueControlsFailure(err)));
  }
}

export function openPlanPage(plan_id){
  history.push(LOAD_PLAN_PATH.replace(':plan_id', plan_id))
}



// WEBPACK FOOTER //
// ./src/actions/control.js